<kpd-spinner type="overlay" *ngIf="loading"></kpd-spinner>

<kpd-entity-not-assigned
  icon="users"
  [header]="'No roles assigned' | translate"
  [description]="'Edit this user to assign them available roles.' | translate"
  *ngIf="!loading && applicationsWithRoles && applicationsWithRoles.length === 0"
></kpd-entity-not-assigned>
<div *ngFor="let application of applicationsWithRoles">
  <app-user-details-permissions-application *ngIf="application.roles.length > 0" [application]="application">
  </app-user-details-permissions-application>
</div>
